// extracted by mini-css-extract-plugin
export default {"thanks":"index_thanks_HYw0v","item":"index_item_E8M-U"};